import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Loader2, CheckCircle, AlertTriangle, ArrowRight } from 'lucide-react';

/**
 * Landing page Stripe redirects talent to after onboarding.
 * Pulls latest status and routes accordingly.
 */
const PayoutsReturn = ({ mode = 'return' }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get('/talent/payouts/status');
        setStatus(res.data);
      } catch (e) {
        setStatus({ error: e.response?.data?.detail || 'Could not load status' });
      } finally { setLoading(false); }
    })();
  }, []);

  const ready = status?.payouts_enabled && status?.details_submitted;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-cyan-50/30 px-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> :
             ready ? <CheckCircle className="w-5 h-5 text-emerald-600" /> :
                    <AlertTriangle className="w-5 h-5 text-amber-600" />}
            {loading ? 'Checking your status…' :
             ready  ? 'You’re ready to be paid!' :
             mode === 'refresh' ? 'Let’s finish your setup' : 'A few more details needed'}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3" data-testid="payouts-return">
          {loading ? (
            <p className="text-sm text-gray-500">Reading the latest from Stripe…</p>
          ) : ready ? (
            <p className="text-sm text-gray-700">
              Your bank account is connected and payouts are enabled. You’ll receive direct deposits automatically after completed jobs.
            </p>
          ) : (
            <p className="text-sm text-gray-700">
              Stripe still needs a few items from you before we can route payouts to your bank.
              {(status?.requirements?.currently_due || []).length > 0 && (
                <> <span className="font-semibold">
                  {status.requirements.currently_due.length} item{status.requirements.currently_due.length === 1 ? '' : 's'} outstanding.
                </span></>
              )}
            </p>
          )}
          <Button
            onClick={() => navigate('/talent/earnings')}
            className="w-full bg-cyan-600 hover:bg-cyan-700 text-white"
            data-testid="payouts-return-continue"
          >
            Back to Earnings <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PayoutsReturn;
